import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useFlags } from "launchdarkly-react-client-sdk";

import ProfileStrip from "components/common/ProfileStrip";
import PageLoader from "components/common/PageLoader";
import WeeklyScheduleTooltip from "components/common/WeeklyScheduleTooltip";
import { getValue } from "components/Screens/CommonUtils";

import { employeeSalaryInfo } from "store/actions/Workforce/EmployeeDetils/SalaryInfo";
import { getEmployeeSchedule } from "services/CheckInCheckOut/CheckInAndBreaks";

import "./EmployeeProfileStrip.scss";

export default function EmployeeProfileStrip({ employeeDetails }) {
  const dispatch = useDispatch();
  const { checkInRevamped } = useFlags();

  const salaryInfo = useSelector((state) => state.SalaryInfo);
  const loadingEmployeeSalaryInfo = useSelector((state) => state.SalaryInfo.loadingEmployeeSalaryInfo);

  const schedule = employeeDetails?.attendanceDetails?.schedule;
  const [fullSchedule, setFullSchedule] = useState(null);

  useEffect(() => {
    if (employeeDetails?.status === "assigned" && employeeDetails?.employeeId) {
      dispatch(employeeSalaryInfo({ request: `employee/${employeeDetails?.employeeId}/salary` }));
      if (checkInRevamped) {
        fetchFullSchedule();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeDetails?.employeeId]);

  const fetchFullSchedule = async () => {
    try {
      const response = await getEmployeeSchedule(employeeDetails?.employeeId);
      if (response?.schedule) {
        setFullSchedule(response.schedule);
      }
    } catch (error) {
      // console.error("Error fetching full schedule:", error);
    }
  };

  const getSalary = (salary) => {
    if (!salary) {
      return "N/A";
    }

    const finalSalary = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    }).format(salary);
    return finalSalary;
  };

  const formatShiftTime = (startTime, endTime) => {
    if (!startTime || !endTime) {
      return "N/A";
    }
    const formatTime = (time) => {
      const [hours, minutes] = time.split(":").map(Number);
      const period = hours >= 12 ? "PM" : "AM";
      const displayHours = hours % 12 || 12;
      return `${displayHours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")} ${period}`;
    };

    return `${formatTime(startTime)} → ${formatTime(endTime)}`;
  };

  return (
    <>
      {loadingEmployeeSalaryInfo && <PageLoader />}
      <ProfileStrip userData={employeeDetails} leaveStatus image showIcon type="employee" />
      {employeeDetails?.status === "assigned" && (
        <div className="assignment-information-card mt-15">
          <div className="custom-section-container w-full">
            <p className="overline-md text-headings-secondary">ASSIGNED TO</p>
            <p className="heading-h4-semibold">{getValue(employeeDetails?.customerInfo?.companyName, "N/A")}</p>
            <p className="heading-h5-medium color-text-primary">
              {getValue(employeeDetails?.customerInfo?.designation, "N/A")}
            </p>

            <div className="section-child mt-1">
              <p className="para-body-xs-regular pb-2p color-text-highlight">Assigned On</p>
              <p className="para-body-s-regular">
                {moment(employeeDetails?.customerInfo?.joiningDate).format("MMM DD, YYYY")}
              </p>
            </div>
            {schedule && (
              <div className="section-child">
                <p className="para-body-xs-regular pb-2p color-text-highlight">Shift time</p>
                <div className="flex items-center gap-025">
                  <div className="para-body-s-regular">{formatShiftTime(schedule.startTime, schedule.endTime)}</div>
                  {checkInRevamped && (
                    <WeeklyScheduleTooltip employeeId={employeeDetails?.employeeId} schedule={fullSchedule} />
                  )}
                </div>
              </div>
            )}
            <div className="section-child">
              <p className="para-body-xs-regular pb-2p color-text-highlight">Salary</p>
              <p className="para-body-s-regular">{getSalary(salaryInfo?.employeeSalaryInfo?.payload?.grossSalary)}</p>
            </div>

            {/* this will be included later once manager logic will be implementeds */}
            {/* <div className="section-child">
              <p className="para-body-xs-regular pb-2p color-text-highlight">Manager</p>
              <p className="para-body-s-regular">N/A</p>
            </div> */}
          </div>
        </div>
      )}
    </>
  );
}
